export const homePage = {
    numberSte: '数量: <span class="color-green">{count}</span> NFT',
    title: 'AIS 的 NFT 合集',
    titleContent: '购买 INO 的条件：',
    lineContent1: '已验证身份',
    lineContent2: ', 每个账户最多可购买 1 件男款衬衫和 1 件女款衬衫',
    buttonBuy: '购买',
    soldOut: '售罄',
    numberProducts: 'SL: <span class="color-red">{count}</span> NFT',
    noLoginTitle: '您还没登录',
    contentNoLogin: '您需要登录才能购买 NFT。',
    buttonNoLogin: '登录',
    buttonVerify: '身份验证',
    changePass: '更改密码',
    logOut: '登出',
    ok: '确认',
    noVerifyTitle: '您尚未验证身份',
    chooseWallet: '选择支付钱包',
    notEnoughMoney: '您的余额不足。',
    confirmBuy: '确认购买NFT',
    price: '购买售价',
    confirmBuyButton: '确认购买',
    loginBuy: '登录购买',
    timeup: '销售已结束',
    remain: '剩余： {remain}',
    confirmSellButton: '卖出',
    titleConnectWallet: '请连接钱包',
    youNeedConnectMetamask: '您需要连接钱包才能购买 NFT。',
    connectWallet: '连接钱包',
    noVerifyContent: '您需要验证身份才能购买NFT。',
    noVerifyButton: '验证',
    rejectVerifyTitle: '您的帐户已被\n 拒绝身份验证',
    rejectVerifyContent: '需要重新认证才能购买NFT',
    rejectVerifyButton: '重新验证',
    pendingVerifyTitle: '您的帐户正在\n 等待验证',
    penddingVerifyButton: 'Ok',

    approvedTitle: '即将开售',
    approvedSubTitle1: '开始销售于：',
    approvedLine1: '2022 年 6 月 21 日 08:00 UTC',
    approvedLine2: ' 第二期：2022年6月18日15:00 70件女款训练衫NFT开启发售',
    approvedSubTitle2: '购买条件',
    approvedLine3:
        '第三期：2022年6月21日15:00 70件男款训练衫NFT、30件女款训练衫NFT开启发售',
    approvedLine4: 'NFT男款衬衫总数为100，女款衬衫总数为100',
    approvedLine5: '每个账户最多可购买 1 件男款衬衫和 1 件女款衬衫',
    approvedLine6: '注册账号并验证身份',
    approvedButton: 'Ok',

    connectPayButton: '连接钱包',
    pedding: '待确认',
    peddingTitle: '您的帐户正在等待\n 验证',
    successVerifyTitle: '您的帐户已经\n 验证',
    successVerifyButton: 'Ok',
    message: {
        titleConnectWallet: '连接钱包.',
        deviceNotSupport: '设备不受支持。',
        connectFail: '连接失败。',
        opened: '请打开metamask窗口以确认登录。',
    },
    buttonRegister: '立即注册',
    buttonTextVerify: '立即验证',
    newItemTitle: '最新信息',
    walletTitle: '钱包',
    walletBalance: '余额',
    loadWallet: '充值',
    loadWalletTitle: '充值',
    loadWalletContent: 'BNB Smart Chain (BEP20)',
    loadWalletSubContent: '将 AIS、SB、BNB、USDT 发送到这个正确的钱包地址。',
    walletAddress: '钱包地址',
    scanAddress: '扫码收款',
    withdrawWallet: '提取',
    withdrawWalletTitle: '提取 STE',
    commonSoon: '即将推出',
    okie: 'Ok',
    copyAddress: '复制钱包地址成功',
    productTitle: 'AIS 的 NFT 合集',
    remainTimeBuy: '剩余发售时间： ',
    bannerTitle: '发现最好的优质、独特和独家的 NFT 合集',
    line1: '2022 年 6 月 21 日 08:00 UTC',
    line2: ' 第二期：2022年6月18日15:00 70件女款训练衫NFT开启发售',
    bannerSubTitle: '购买条件',
    line3: '第三期：2022年6月21日15:00 70件男款训练衫NFT、30件女款训练衫NFT开启发售',
    line4: 'NFT男款衬衫总数为100，女款衬衫总数为100',
    line5: ', 每个账户最多可购买 1 件男款衬衫和 1 件女款衬衫',
    line6: '注册账号并验证身份',
    haveOwned: '已经拥有',
    modalFire: {
        title: '恭喜！',
        subTitle: 'INO STE <span>{count}</span> 期已结束',
        content1: '恭喜会员们成功\n拥有NFT STE',
        content2:
            ' 如果您这次没有运气，请加入 15:00（越南）的 <span>{count}</span> 时段',
        stage1: ' 6月18日来临',
        stage2: ' 6月21日来临',
    },
    coming_soon: 'COMING SOON',
    download: '下载',


    filter_order: '排序',
    filter_nft: '按 NFT 类型过滤',
    filter_mint: '按mint次数过滤',
    filter_token: '过滤token类型',
    newest: '最新',
    price_asc: '售价：从低到高 ↑',
    price_desc: '售价：从高到低 ↓',
    all: '全部',
    nft_m: 'NFT M',
    nft_w: 'NFT W',
    nft_s: 'NFT S',
    nft_us: 'NFT US',
    nft_os: 'NFT OS',
    mint_couple: '双 Mint',
    last1: '还剩 1 次',
    last2: '还剩 2 次',
    last3: '还剩 3 次',
    last4: '还剩 4 次',
    last5: '还剩 5 次',
    last6: '还剩 6 次',
    last7: '还剩 7 次',
    new: '新的',
    expire: '培训期满',
    cancel_sell: '取消销售',
    confirm_cancel: '取消销售 NFT',
    price_sell: '售价：',
    fee: '5% 销售费：',
    ste_receive: '{0}将收到：',
    couple_des: '已互相 mint 的 NFT 必须成对交易（NFT M 和 NFT W）。',
    invite: '推荐朋友',
    invite_title: '邀请朋友',
    rule: '规定',
    rule1: '与没有帐户的朋友分享您的推荐/连接ID',
    rule2: '被推荐人必须成功验证身份并参加培训',
    rule3: '每次成功推荐，您将获得额外 4 天的免费玩游戏时间',
    id_invite: '您的推荐ID',
    linkref: 'Link invite',
    ref_code: '推荐码',
    copy_success: '复制成功！',
    condition_sell: '出售 NFT 的条件',
    condition_sell1: '1. NFT 是新的（未使用）。',
    condition_sell2: '2. 使用过的NFT需要获得7次以上的奖励（获得少于7次的NFT不能出售）',
    condition_sell3: '3. 已互相 mint 的 NFT 必须成对交易（NFT M 和 NFT W）。',
    condition_sell4: '4. 发布销售时使用和获得奖励7次或以上的NFT将继续计算日期直到到期日，当有人购买时，到期日将自动过期， 如果卖家取消销售，到期日将等于正在计算的天数.\n',
    condition_sell5: '5. 上架销售的 NFT 不得用于训练.\n。',
    condition_sell6: '6. 使用过的NFT必须还有Mint 次数。',
    nft_not_mint: '还没有 Mint 的 NFT',
    sell: '卖出',
    confirm_sell: 'NFT销售确认',
    transfer_confirm: 'NFT转让确认',
    fee_transfer: '转让费：',
    sell_placeholder: '输入售价',
    valid_price: '请输入售价',
    priceSellRequired: '请输入售价',
    confirm_text: '确认',
    change_price: '修改售价',
    change_price_title: '修改NFT售价',
    sell_success: '成功发布nft销售！',
    nft_minted: '已 Mint 的NFT',
    history_title: '历史',
    history_text: '交易历史',
    nft_transaction: 'NFT交易',
    ste_transaction: 'STE交易',
    stt: '序号',
    time: '时间',
    type_transaction: '交易类型',
    type_nft: 'NFT类型',
    id_nft: 'NFT ID',
    price_nft: '售价',
    transfer_nft: '发送者/接收者',
    fee_nft: '费用',
    type_wallet: '钱包类型',
    total: '金额',
    hash: 'Hash',
    wallet_to: '接收钱包地址',
    status: '状态',
    copySuccess: '复制成功',
    copyFail: '复制失败',
    not_available: 'NFT 已售出或无法使用！',
    transfer: "转让",
    collaborators_title: "合作者"
};
